import * as Types from '../../../../types.generated';

import * as types from '@src/types';
import { gql } from '@apollo/client';
import { CourseLibraryItemQrCodeFragmentDoc } from '../CourseDetailPageHeader.generated';
import { CoverImageFragmentDoc, MediaFragmentDoc, TrainingResourceVersionFragmentDoc, ContentSharingPermissionFragmentDoc, TranslationSetFragmentDoc, ContentTagMembershipFragmentDoc, ImageUrlsFragmentDoc, AutomationFragmentDoc, ContentQrCodeFragmentDoc, AiGenerateModuleRequestFragmentDoc, UserSelectionFragmentDoc, PathInstanceThinFragmentDoc, RichTextDocumentFragmentDoc, ConvertMediaToRichTextDocumentWorkflowFragmentDoc, BlastSentRecordFragmentDoc, TrainingResourceFragmentDoc } from '../../../../fragments.generated';
import { CourseVersionGradeFragmentDoc } from './settingsPane/TabbedCourseSettingsPane.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CourseVersionQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type CourseVersionQuery = { __typename?: 'Query', AdminCourseVersion?: { __typename?: 'CourseVersion', id: number, publishedAt?: string | null, archivedPublishState?: Types.PublishState | null, createdAt: string, course: { __typename?: 'Course', id: number, publishedAt?: string | null, enableCertificate: boolean, enablePromptRetries: boolean, assignableByManagers: boolean, passingAccuracyThreshold?: number | null, lastBuilderActionId?: number | null, isAIGenerated?: boolean | null, publishedVersion?: { __typename?: 'CourseVersion', id: number } | null, draftVersion: { __typename?: 'CourseVersion', id: number }, scormUpload?: { __typename?: 'SCORMUpload', completedAt?: string | null } | null, libraryItem: { __typename?: 'LibraryItem', id: string, dueDate?: string | null, dueDateDays?: number | null, publishState?: Types.PublishState | null, createdAt: string, archivedAt?: string | null, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string } | null, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, sharingPermissions: { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } }> }, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, createdBy?: { __typename?: 'Employee', id: number, name: string } | null, org?: { __typename?: 'Org', id: number } | null, aiGenerationFeedback?: { __typename?: 'AIGenerationFeedback', id?: string | null } | null } }, lessons: Array<{ __typename?: 'Lesson', uuid: string, name: string, prompts: Array<{ __typename?: 'Prompt', id: number, uuid: string, type: Types.PromptType, assignMedia: boolean, mediaId?: number | null, libraryItemLinkId?: string | null, correctTfAnswer?: boolean | null, selectAllThatApply: boolean, imageOnlyMatchItems?: boolean | null, aiGenerationInProgress: boolean, hideMediaSuggestions: boolean, requireFullVideoPlayback: boolean, text?: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } | null, correctFreeResponseAnswer?: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } | null, responseOptions: Array<{ __typename?: 'ResponseOption', id: string, mediaId?: number | null, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, matchItem?: { __typename?: 'MatchItem', id: string, mediaId?: number | null, text: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null }>, mediaSuggestions?: Array<{ __typename?: 'MediaSuggestion', id: string, media: { __typename?: 'Media', id: number } }> | null }>, aiLessonGeneration?: { __typename?: 'AILessonGeneration', id: string, titleAttempted: boolean, messagePromptsAttempted: boolean, messagePromptsSuccess: boolean, questionPromptsAttempted: boolean, questionPromptsSuccess: boolean } | null }>, grade?: { __typename?: 'CourseVersionGrade', id: string, totalScore: number, grade: number, feedbackMd: string, sections: Array<{ __typename?: 'SectionGrade', id: string, name: string, score: number, maxScore: number, feedback: string, subsections: Array<{ __typename?: 'SubsectionGrade', id: string, name: string, score: number, maxScore: number, feedback: string }>, actionItems: Array<{ __typename?: 'GradeActionItem', id: string, action: string, suggestion: string, priority: Types.ActionItemPriority }> }> } | null } | null };

export type ApplyBuilderActionsMutationVariables = Types.Exact<{
  actions: Array<Types.BuilderActionInput> | Types.BuilderActionInput;
}>;


export type ApplyBuilderActionsMutation = { __typename?: 'Mutation', applyBuilderActions: { __typename?: 'ApplyBuilderActionsMutationResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, appliedBuilderActions?: Array<{ __typename?: 'BuilderAction', uuid: string }> | null } };

export type SetActiveClientMutationVariables = Types.Exact<{
  input: Types.SetActiveClientInput;
}>;


export type SetActiveClientMutation = { __typename?: 'Mutation', setActiveClient: { __typename?: 'ActiveClientMutationResult', success: boolean } };

export type RemoveActiveClientMutationVariables = Types.Exact<{
  clientId: Types.Scalars['String'];
}>;


export type RemoveActiveClientMutation = { __typename?: 'Mutation', removeActiveClient: { __typename?: 'BaseMutationResult', success: boolean } };

export type CourseContentCourseFragment = { __typename?: 'Course', id: number, publishedAt?: string | null, enableCertificate: boolean, enablePromptRetries: boolean, assignableByManagers: boolean, passingAccuracyThreshold?: number | null, lastBuilderActionId?: number | null, isAIGenerated?: boolean | null, publishedVersion?: { __typename?: 'CourseVersion', id: number } | null, draftVersion: { __typename?: 'CourseVersion', id: number }, scormUpload?: { __typename?: 'SCORMUpload', completedAt?: string | null } | null, libraryItem: { __typename?: 'LibraryItem', id: string, dueDate?: string | null, dueDateDays?: number | null, publishState?: Types.PublishState | null, createdAt: string, archivedAt?: string | null, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string } | null, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, sharingPermissions: { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } }> }, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, createdBy?: { __typename?: 'Employee', id: number, name: string } | null, org?: { __typename?: 'Org', id: number } | null, aiGenerationFeedback?: { __typename?: 'AIGenerationFeedback', id?: string | null } | null } };

export type CourseContentCourseVersionFragment = { __typename?: 'CourseVersion', id: number, publishedAt?: string | null, archivedPublishState?: Types.PublishState | null, createdAt: string, course: { __typename?: 'Course', id: number, publishedAt?: string | null, enableCertificate: boolean, enablePromptRetries: boolean, assignableByManagers: boolean, passingAccuracyThreshold?: number | null, lastBuilderActionId?: number | null, isAIGenerated?: boolean | null, publishedVersion?: { __typename?: 'CourseVersion', id: number } | null, draftVersion: { __typename?: 'CourseVersion', id: number }, scormUpload?: { __typename?: 'SCORMUpload', completedAt?: string | null } | null, libraryItem: { __typename?: 'LibraryItem', id: string, dueDate?: string | null, dueDateDays?: number | null, publishState?: Types.PublishState | null, createdAt: string, archivedAt?: string | null, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string } | null, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, sharingPermissions: { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } }> }, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, createdBy?: { __typename?: 'Employee', id: number, name: string } | null, org?: { __typename?: 'Org', id: number } | null, aiGenerationFeedback?: { __typename?: 'AIGenerationFeedback', id?: string | null } | null } }, lessons: Array<{ __typename?: 'Lesson', uuid: string, name: string, prompts: Array<{ __typename?: 'Prompt', id: number, uuid: string, type: Types.PromptType, assignMedia: boolean, mediaId?: number | null, libraryItemLinkId?: string | null, correctTfAnswer?: boolean | null, selectAllThatApply: boolean, imageOnlyMatchItems?: boolean | null, aiGenerationInProgress: boolean, hideMediaSuggestions: boolean, requireFullVideoPlayback: boolean, text?: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } | null, correctFreeResponseAnswer?: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } | null, responseOptions: Array<{ __typename?: 'ResponseOption', id: string, mediaId?: number | null, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, matchItem?: { __typename?: 'MatchItem', id: string, mediaId?: number | null, text: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null }>, mediaSuggestions?: Array<{ __typename?: 'MediaSuggestion', id: string, media: { __typename?: 'Media', id: number } }> | null }>, aiLessonGeneration?: { __typename?: 'AILessonGeneration', id: string, titleAttempted: boolean, messagePromptsAttempted: boolean, messagePromptsSuccess: boolean, questionPromptsAttempted: boolean, questionPromptsSuccess: boolean } | null }>, grade?: { __typename?: 'CourseVersionGrade', id: string, totalScore: number, grade: number, feedbackMd: string, sections: Array<{ __typename?: 'SectionGrade', id: string, name: string, score: number, maxScore: number, feedback: string, subsections: Array<{ __typename?: 'SubsectionGrade', id: string, name: string, score: number, maxScore: number, feedback: string }>, actionItems: Array<{ __typename?: 'GradeActionItem', id: string, action: string, suggestion: string, priority: Types.ActionItemPriority }> }> } | null };

export type CourseContentLessonFragment = { __typename?: 'Lesson', uuid: string, name: string, prompts: Array<{ __typename?: 'Prompt', id: number, uuid: string, type: Types.PromptType, assignMedia: boolean, mediaId?: number | null, libraryItemLinkId?: string | null, correctTfAnswer?: boolean | null, selectAllThatApply: boolean, imageOnlyMatchItems?: boolean | null, aiGenerationInProgress: boolean, hideMediaSuggestions: boolean, requireFullVideoPlayback: boolean, text?: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } | null, correctFreeResponseAnswer?: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } | null, responseOptions: Array<{ __typename?: 'ResponseOption', id: string, mediaId?: number | null, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, matchItem?: { __typename?: 'MatchItem', id: string, mediaId?: number | null, text: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null }>, mediaSuggestions?: Array<{ __typename?: 'MediaSuggestion', id: string, media: { __typename?: 'Media', id: number } }> | null }>, aiLessonGeneration?: { __typename?: 'AILessonGeneration', id: string, titleAttempted: boolean, messagePromptsAttempted: boolean, messagePromptsSuccess: boolean, questionPromptsAttempted: boolean, questionPromptsSuccess: boolean } | null };

export type CourseContentPromptFragment = { __typename?: 'Prompt', id: number, uuid: string, type: Types.PromptType, assignMedia: boolean, mediaId?: number | null, libraryItemLinkId?: string | null, correctTfAnswer?: boolean | null, selectAllThatApply: boolean, imageOnlyMatchItems?: boolean | null, aiGenerationInProgress: boolean, hideMediaSuggestions: boolean, requireFullVideoPlayback: boolean, text?: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } | null, correctFreeResponseAnswer?: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } | null, responseOptions: Array<{ __typename?: 'ResponseOption', id: string, mediaId?: number | null, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, matchItem?: { __typename?: 'MatchItem', id: string, mediaId?: number | null, text: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null }>, mediaSuggestions?: Array<{ __typename?: 'MediaSuggestion', id: string, media: { __typename?: 'Media', id: number } }> | null };

export type ResponseOptionFragment = { __typename?: 'ResponseOption', id: string, mediaId?: number | null, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, matchItem?: { __typename?: 'MatchItem', id: string, mediaId?: number | null, text: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null };

export type ActiveClientFragment = { __typename?: 'ActiveClient', promptUuid?: string | null, courseVersionId?: number | null, pathVersionId?: string | null, skillVersionId?: string | null, verificationStepId?: string | null, pathContentMembershipId?: string | null, richTextDocumentId?: string | null, clientId: string, user: { __typename?: 'Employee', id: number, name: string } };

export type CourseContentRedirectQueryVariables = Types.Exact<{
  courseId: Types.Scalars['Int'];
}>;


export type CourseContentRedirectQuery = { __typename?: 'Query', AdminCourse?: { __typename?: 'Course', id: number, libraryItem: { __typename?: 'LibraryItem', id: string }, draftVersion: { __typename?: 'CourseVersion', id: number } } | null };

export const CourseContentCourseFragmentDoc = gql`
    fragment CourseContentCourse on Course {
  id
  publishedAt
  publishedVersion {
    id
  }
  draftVersion {
    id
  }
  scormUpload {
    completedAt
  }
  enableCertificate
  enablePromptRetries
  assignableByManagers
  passingAccuracyThreshold
  lastBuilderActionId
  libraryItem {
    id
    qrCode {
      ...CourseLibraryItemQRCode
    }
    coverImage {
      ...CoverImage
    }
    dueDate
    dueDateDays
    sharingPermissions {
      ...ContentSharingPermission
    }
    publishState
    name {
      ...TranslationSet
    }
    description {
      ...TranslationSet
    }
    createdBy {
      id
      name
    }
    createdAt
    archivedAt
    org {
      id
    }
    aiGenerationFeedback {
      id
    }
  }
  isAIGenerated
}
    ${CourseLibraryItemQrCodeFragmentDoc}
${CoverImageFragmentDoc}
${ContentSharingPermissionFragmentDoc}
${TranslationSetFragmentDoc}`;
export const ResponseOptionFragmentDoc = gql`
    fragment ResponseOption on ResponseOption {
  id
  mediaId
  answer {
    ...TranslationSet
  }
  matchItem {
    id
    text {
      ...TranslationSet
    }
    mediaId
  }
  isCorrect
}
    ${TranslationSetFragmentDoc}`;
export const CourseContentPromptFragmentDoc = gql`
    fragment CourseContentPrompt on Prompt {
  id
  uuid
  type
  assignMedia
  text {
    ...TranslationSet
  }
  mediaId
  libraryItemLinkId
  correctTfAnswer
  correctFreeResponseAnswer {
    ...TranslationSet
  }
  responseOptions {
    ...ResponseOption
  }
  selectAllThatApply
  imageOnlyMatchItems
  mediaSuggestions {
    id
    media {
      id
    }
  }
  aiGenerationInProgress
  hideMediaSuggestions
  requireFullVideoPlayback
}
    ${TranslationSetFragmentDoc}
${ResponseOptionFragmentDoc}`;
export const CourseContentLessonFragmentDoc = gql`
    fragment CourseContentLesson on Lesson {
  uuid
  name
  prompts {
    ...CourseContentPrompt
  }
  aiLessonGeneration {
    id
    titleAttempted
    messagePromptsAttempted
    messagePromptsSuccess
    questionPromptsAttempted
    questionPromptsSuccess
  }
}
    ${CourseContentPromptFragmentDoc}`;
export const CourseContentCourseVersionFragmentDoc = gql`
    fragment CourseContentCourseVersion on CourseVersion {
  id
  publishedAt
  archivedPublishState
  createdAt
  course {
    ...CourseContentCourse
  }
  lessons {
    ...CourseContentLesson
  }
  grade {
    ...CourseVersionGrade
  }
}
    ${CourseContentCourseFragmentDoc}
${CourseContentLessonFragmentDoc}
${CourseVersionGradeFragmentDoc}`;
export const ActiveClientFragmentDoc = gql`
    fragment ActiveClient on ActiveClient {
  promptUuid
  courseVersionId
  pathVersionId
  skillVersionId
  verificationStepId
  pathContentMembershipId
  richTextDocumentId
  clientId
  user {
    id
    name
  }
}
    `;
export const CourseVersionDocument = gql`
    query CourseVersion($id: Int!) {
  AdminCourseVersion(id: $id) {
    ...CourseContentCourseVersion
  }
}
    ${CourseContentCourseVersionFragmentDoc}`;

/**
 * __useCourseVersionQuery__
 *
 * To run a query within a React component, call `useCourseVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseVersionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseVersionQuery(baseOptions: Apollo.QueryHookOptions<CourseVersionQuery, CourseVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseVersionQuery, CourseVersionQueryVariables>(CourseVersionDocument, options);
      }
export function useCourseVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseVersionQuery, CourseVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseVersionQuery, CourseVersionQueryVariables>(CourseVersionDocument, options);
        }
export type CourseVersionQueryHookResult = ReturnType<typeof useCourseVersionQuery>;
export type CourseVersionLazyQueryHookResult = ReturnType<typeof useCourseVersionLazyQuery>;
export type CourseVersionQueryResult = Apollo.QueryResult<CourseVersionQuery, CourseVersionQueryVariables>;
export const ApplyBuilderActionsDocument = gql`
    mutation applyBuilderActions($actions: [BuilderActionInput!]!) {
  applyBuilderActions(actions: $actions) {
    success
    error {
      code
      message
    }
    appliedBuilderActions {
      uuid
    }
  }
}
    `;
export type ApplyBuilderActionsMutationFn = Apollo.MutationFunction<ApplyBuilderActionsMutation, ApplyBuilderActionsMutationVariables>;

/**
 * __useApplyBuilderActionsMutation__
 *
 * To run a mutation, you first call `useApplyBuilderActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyBuilderActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyBuilderActionsMutation, { data, loading, error }] = useApplyBuilderActionsMutation({
 *   variables: {
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function useApplyBuilderActionsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyBuilderActionsMutation, ApplyBuilderActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyBuilderActionsMutation, ApplyBuilderActionsMutationVariables>(ApplyBuilderActionsDocument, options);
      }
export type ApplyBuilderActionsMutationHookResult = ReturnType<typeof useApplyBuilderActionsMutation>;
export type ApplyBuilderActionsMutationResult = Apollo.MutationResult<ApplyBuilderActionsMutation>;
export type ApplyBuilderActionsMutationOptions = Apollo.BaseMutationOptions<ApplyBuilderActionsMutation, ApplyBuilderActionsMutationVariables>;
export const SetActiveClientDocument = gql`
    mutation SetActiveClient($input: SetActiveClientInput!) {
  setActiveClient(input: $input) {
    success
  }
}
    `;
export type SetActiveClientMutationFn = Apollo.MutationFunction<SetActiveClientMutation, SetActiveClientMutationVariables>;

/**
 * __useSetActiveClientMutation__
 *
 * To run a mutation, you first call `useSetActiveClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveClientMutation, { data, loading, error }] = useSetActiveClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetActiveClientMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveClientMutation, SetActiveClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveClientMutation, SetActiveClientMutationVariables>(SetActiveClientDocument, options);
      }
export type SetActiveClientMutationHookResult = ReturnType<typeof useSetActiveClientMutation>;
export type SetActiveClientMutationResult = Apollo.MutationResult<SetActiveClientMutation>;
export type SetActiveClientMutationOptions = Apollo.BaseMutationOptions<SetActiveClientMutation, SetActiveClientMutationVariables>;
export const RemoveActiveClientDocument = gql`
    mutation RemoveActiveClient($clientId: String!) {
  removeActiveClient(clientId: $clientId) {
    success
  }
}
    `;
export type RemoveActiveClientMutationFn = Apollo.MutationFunction<RemoveActiveClientMutation, RemoveActiveClientMutationVariables>;

/**
 * __useRemoveActiveClientMutation__
 *
 * To run a mutation, you first call `useRemoveActiveClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveActiveClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeActiveClientMutation, { data, loading, error }] = useRemoveActiveClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useRemoveActiveClientMutation(baseOptions?: Apollo.MutationHookOptions<RemoveActiveClientMutation, RemoveActiveClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveActiveClientMutation, RemoveActiveClientMutationVariables>(RemoveActiveClientDocument, options);
      }
export type RemoveActiveClientMutationHookResult = ReturnType<typeof useRemoveActiveClientMutation>;
export type RemoveActiveClientMutationResult = Apollo.MutationResult<RemoveActiveClientMutation>;
export type RemoveActiveClientMutationOptions = Apollo.BaseMutationOptions<RemoveActiveClientMutation, RemoveActiveClientMutationVariables>;
export const CourseContentRedirectDocument = gql`
    query CourseContentRedirect($courseId: Int!) {
  AdminCourse(id: $courseId) {
    id
    libraryItem {
      id
    }
    draftVersion {
      id
    }
  }
}
    `;

/**
 * __useCourseContentRedirectQuery__
 *
 * To run a query within a React component, call `useCourseContentRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseContentRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseContentRedirectQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseContentRedirectQuery(baseOptions: Apollo.QueryHookOptions<CourseContentRedirectQuery, CourseContentRedirectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseContentRedirectQuery, CourseContentRedirectQueryVariables>(CourseContentRedirectDocument, options);
      }
export function useCourseContentRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseContentRedirectQuery, CourseContentRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseContentRedirectQuery, CourseContentRedirectQueryVariables>(CourseContentRedirectDocument, options);
        }
export type CourseContentRedirectQueryHookResult = ReturnType<typeof useCourseContentRedirectQuery>;
export type CourseContentRedirectLazyQueryHookResult = ReturnType<typeof useCourseContentRedirectLazyQuery>;
export type CourseContentRedirectQueryResult = Apollo.QueryResult<CourseContentRedirectQuery, CourseContentRedirectQueryVariables>;